import { formatDateTime } from "../../../../utils/constants";

export const formatTeamUserTimestamps = (user) => ({
    ...user,
    created_at_timestamp: formatDateTime(user?.created_at_timestamp, "dmy24hrFormat"),
    updated_at_timestamp: formatDateTime(user?.updated_at_timestamp, "dmy24hrFormat"),
});

export const formatOrganizationTeam = (team) => ({
    ...team,
    organization_team_users: team?.organization_team_users?.map(formatTeamUserTimestamps) ?? [],
});

export const formatOrganizationTeamsList = (teams) => {
    return teams?.map(formatOrganizationTeam) ?? null;
}